import React from 'react';
import Skeleton from 'react-loading-skeleton';


export default function Receiver(props) {
    return (

        <div className="row mt-5">
          <div className="col-md-12">
            {
              props.loading ? (
                <Skeleton />
              ) : (
                  <h3 className="text-dark">
                    Olá, você está pagando a {props.nome_lojista} - {props.documento_lojista}
                  </h3>
                )
            }

          </div>
        </div>


    )
}
